export default function fetchStateFromHtml(id = 'initialJsState') {
    return JSON.parse(document.getElementById(id).textContent);
}
